import { useState } from "react";
import { DEVICE_TYPES, USER_VIEW } from "../../../common/constant/common-constants";
import { ALARM_PRIORITY } from "../../../common/constant/common-constants";
import { handleOutsideClick } from "../../../common/utils/CommonUtils";
import moment from 'moment';
import blackDownArrow from "../../../common/icons/svg/black-down-arrow.svg";
import blackUpArrow from "../../../common/icons/svg/black-up-arrow.svg";
import whiteUpArrow from "../../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../../common/icons/svg/white-down-arrow.svg";
import DeviceTabDesktopView from "./DeviceTabDesktopView";
import DeviceTabMobileView from "./DeviceTabMobileView";

// import low-priority from "../../../common/icons/alarm/low-priority-alarm.png";
import { PATIENT_TYPE } from "../../../common/ENUMS/PARAMETER_ENUM";
import { TEMP_MODE } from "../../../common/ENUMS/VENTILATOR_MODES_ENUM";
import { connect } from "react-redux";

function DevicesTab({ alarmData, handleSeeAllAlarms, activeVitalDevice, modeData, ...props }) {
    const [showMoreAlarms_1, setShowMoreAlarms_1] = useState(null);
    const [showMoreAlarms_2, setShowMoreAlarms_2] = useState(null);



    const getAlarmPriorityClass = (alarmData) => {
        // let id = bedId && bedId.toString();
        switch (alarmData?.priority?.toLocaleUpperCase()) {
            case "HIGH":
                return ALARM_PRIORITY.HIGH_PRIORITY;
            case "MEDIUM":
                return ALARM_PRIORITY.MEDIUM_PRIORITY;
            case "LOW":
                return ALARM_PRIORITY.LOW_PRIORITY;
            default:
                return ALARM_PRIORITY.LOW_PRIORITY;
        }
    }

    const handleShowMoreAlarmsClick_1 = (event) => {
        event.stopPropagation();
        setShowMoreAlarms_1(!showMoreAlarms_1);
        if (!showMoreAlarms_1) {
            handleOutsideClick(event, 'alarm-display-bar-1', setShowMoreAlarms_1);
        }
    }

    const handleShowMoreAlarmsClick_2 = (event) => {
        event.stopPropagation();
        setShowMoreAlarms_2(!showMoreAlarms_2);
        if (!showMoreAlarms_2) {
            handleOutsideClick(event, 'alarm-display-bar-2', setShowMoreAlarms_2);
        }
    }

    // console.log("alarmData----->", alarmData)
    const ventilatorConnected = props.ventilatorHeartbeat?.isConnected;
    const user_enabled = props?.ventilatorHeartbeat?.user_enabled

    const monitorConnected = props?.monitorHeartBeatData?.isConnected
    const deviceAlarmData = activeVitalDevice === DEVICE_TYPES['NOCCARC_PM_NX5'] ?
        (monitorConnected ? alarmData?.PM_alarms : []) :
        ventilatorConnected && user_enabled ?
            alarmData?.ventilatorAlarms
            : [];



    return (
        <>
            {props.config.userView === USER_VIEW.DESKTOP && (
                <DeviceTabDesktopView
                    activeVitalDevice={activeVitalDevice}
                    deviceAlarmData={deviceAlarmData}
                    showMoreAlarms_1={showMoreAlarms_1}
                    showMoreAlarms_2={showMoreAlarms_2}
                    handleShowMoreAlarmsClick_1={handleShowMoreAlarmsClick_1}
                    handleShowMoreAlarmsClick_2={handleShowMoreAlarmsClick_2}
                    handleSeeAllAlarms={handleSeeAllAlarms}
                    getAlarmPriorityClass={getAlarmPriorityClass}
                />
            )}

            {props.config.userView === USER_VIEW.MOBILE && (
                <DeviceTabMobileView
                    activeVitalDevice={activeVitalDevice}
                    deviceAlarmData={deviceAlarmData}
                    showMoreAlarms_1={showMoreAlarms_1}
                    showMoreAlarms_2={showMoreAlarms_2}
                    handleShowMoreAlarmsClick_1={handleShowMoreAlarmsClick_1}
                    handleShowMoreAlarmsClick_2={handleShowMoreAlarmsClick_2}
                    handleSeeAllAlarms={handleSeeAllAlarms}
                    getAlarmPriorityClass={getAlarmPriorityClass}
                />
            )}
        </>
    );
}

const mapStateToProps = (state, ownProps) => {
    let bedDetails = state.bedDetailsReducer.bedDetails[ownProps.bedId];
    let ventilatorHeartbeat = state.deviceVitalDataReducer?.ventilatorHeartbeat?.[ownProps.bedId];
    let ventilatorStandby = state.deviceVitalDataReducer?.ventilatorStandby?.[ownProps.bedId];
    let mData = state?.deviceVitalDataReducer?.deviceVitalData?.[ownProps.bedId]?.[DEVICE_TYPES.MONITOR];
    let mHeartBeatData = state?.deviceVitalDataReducer?.monitorHeartbeat?.[ownProps.bedId];
    return {
        bedDetails: bedDetails,
        ventilatorHeartbeat: ventilatorHeartbeat,
        ventilatorStandby: ventilatorStandby,
        config: state.configReducer.config,
        monitorData: mData,
        monitorHeartBeatData: mHeartBeatData,
        alarmData: state?.alarmDataReducer?.alarmData?.[ownProps.bedId],
    };
};

const mapDispatchToProps = dispatch => {
    return {
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DevicesTab);